import React, { useEffect, useRef, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { CModal } from '@coreui/react';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import Pagination from '../components/Pagination';
import { GeneratePdf } from '../components/GeneratePdf';

const MobileRegisterStudentList = () => {
    const authorizedAxios = generateAxiosInstance()
    let instituteMasterId = process.env.REACT_APP_REGISTER_INSTITUTE_ID;

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        list: "incomplete",
    }

    const InstituteDetails = useRef();
    const [studentData, setStudentData] = useState(initialFormState);
    const [studentList, setStudentList] = useState([]);

    const [paymentDetails, setPaymentDetails] = useState([])
    const [visiblePaymentDetails, setVisiblePaymentDetails] = useState()
    const [planList, setPlanList] = useState([])


    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);

    const [saveId, setSaveId] = useState(null);

    const [userNameSort, setUserNameSort] = useState(null);
    const [emailSort, setEmailSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["userUniqueId", "email"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    const getPlanList = async () => {
        try {
            const apiUrl = "/subscription";
            const response = await authorizedAxios.get(apiUrl);
            setPlanList(response.data.data);
        } catch (error) {
            const errorMsg = error?.data?.message || "Something went wrong!";
            console.log("Fetching error data: ", errorMsg);
        }
    }

    useEffect(() => {
        getStudentList();
        getPlanList();
    }, [])

    useEffect(() => {
        getStudentList();
    }, [studentData]);

    const getApiUrl = () => {
        let apiUrl = `/get-app-subscriber-list?`;
        if (studentData.instituteMasterId !== '') {
            apiUrl += `instituteMasterId=${studentData.instituteMasterId}&`;
        }
        if (studentData.list !== '') {
            apiUrl += `list=${studentData.list}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getStudentList = async () => {
        try {
            setLoading(true);
            const response = await authorizedAxios.get(getApiUrl());
            setStudentList(response.data.result);
            InstituteDetails.current = response.data.InstituteMaster;
        } catch (error) {
            setStudentList([]);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getStudentList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setStudentList(await searchArray("A", getApiUrl(), searchKeys, searchValue.trim()));
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(studentList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])


    useEffect(() => {
        setTotalPages(Math.ceil(studentList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > studentList.length) {
            endIndex = studentList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(studentList.slice(startIndex, endIndex));
    }, [studentList, currPage, itemsPerPage])

    useEffect(() => {
        if (userNameSort == true || userNameSort == false) {
            setEmailSort(null);
        }
    }, [userNameSort])

    useEffect(() => {
        if (emailSort == true || emailSort == false) {
            setUserNameSort(null);
        }
    }, [emailSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Subcriber List</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-users-line"></i>Subcriber List</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="d-grid gap-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <button className={`${studentData.list == "incomplete" ? 'active' : ''} btn btn-light btn-width`} onClick={() => { setStudentData(prev => ({ ...prev, list: "incomplete" })); setCurrPage(1) }}>Incomplete List</button>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <button className={`${studentData.list == "complete" ? 'active' : ''} btn btn-light btn-width`} onClick={() => { setStudentData(prev => ({ ...prev, list: "complete" })); setCurrPage(1) }}>Active List</button>
                                                            </div>
                                                        </div>

                                                        {studentList && <GeneratePdf id="subscriberList" title={{ studentList, InstituteMaster: InstituteDetails.current }} headerTitle={studentData.list} />}
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>

                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table" id='subscriberList'>
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            User Name
                                                                            <SortIcon sortState={userNameSort} setSortState={setUserNameSort} setData={setStudentList} setCurrPage={setCurrPage} sortingPath={"userUniqueId"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Email
                                                                            <SortIcon sortState={emailSort} setSortState={setEmailSort} setData={setStudentList} setCurrPage={setCurrPage} sortingPath={"email"} />
                                                                        </th>
                                                                        {studentData.list == "complete" && <th scope='col'>Payment Details</th>}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((std, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{std.userUniqueId}</td>
                                                                                        <td>{std.email}</td>
                                                                                        {studentData.list == "complete" && <td>
                                                                                            <button className="btn btn-primary view_icon" type="button"
                                                                                                onClick={() => { setPaymentDetails(std.paymentOrderDetails); setVisiblePaymentDetails(!visiblePaymentDetails) }}
                                                                                            ><i class="fa fa-eye" ></i></button>
                                                                                        </td>}
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                {studentData.list == "complete" && <th colspan={"100%"} style={{ textAlign: 'center' }}>No Active Students Available</th>}
                                                                                {studentData.list == "incomplete" && <th colspan={"100%"} style={{ textAlign: 'center' }}>No Incomplete Students Available</th>}
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={studentList.length} />
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <CModal
                backdrop="static"
                visible={visiblePaymentDetails}
                onClose={() => setVisiblePaymentDetails(false)}
                aria-labelledby="LiveDemoExampleLabel"
                className="assign-modal"
            >
                <div className="exam-detail-card">
                    <div className="payment-detail-card">
                        <header className="exam-header">
                            <h1 className="exam-title">Payment Details</h1>
                            <button type="button" className="close-btn" aria-label="Close" onClick={() => setVisiblePaymentDetails(false)} >&times;</button>
                        </header>
                        <section className="exam-info">
                            {paymentDetails?.map((paymentDetail, index) => (
                                <div className="info-group">
                                    <h2 className="group-title">Payment Detail {index + 1}</h2>
                                    <div className="info-item">
                                        <span className="label">Order ID:</span>
                                        <span className="value">{paymentDetail.order_id}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="label">Currency:</span>
                                        <span className="value">{paymentDetail.currency}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="label">Receipt:</span>
                                        <span className="value">{paymentDetail.receipt}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="label">Amount:</span>
                                        <span className="value">{paymentDetail.amount}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="label">Payment ID:</span>
                                        <span className="value">{paymentDetail.razor_payment_id}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="label">Payment Status:</span>
                                        <span className="value">{paymentDetail.payment_status ? "Paid" : "Pending"}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="label">Subscription Type:</span>
                                        <span className="value">
                                            {
                                                planList?.map(plan => {
                                                    if (paymentDetail.subscription_type === plan.id) {
                                                        return plan.subscriptionName
                                                    }
                                                })
                                            }
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </section>
                    </div>
                </div>
            </CModal>

            <Footer />
        </>
    )
};

export default MobileRegisterStudentList;